import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

// Label values come from the labels dim rather than the account's label list, so the dropdown offers
// exactly the labels the charted points carry.
export const DashboardLabelFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_LABEL}
      filterName={FilterName.DASHBOARD_LABEL}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="labels"
      // Points carrying no labels dim land in this bucket.
      undefinedString={NONE_NAME}
    />
  )
}
